"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDecodedToken = void 0;
var jwt_1 = require("next-auth/jwt");
function getDecodedToken(params) {
    return (0, jwt_1.getToken)(__assign(__assign({}, params), { secret: params.secret || process.env.NEXTAUTH_SECRET }));
}
exports.getDecodedToken = getDecodedToken;
